package com.gsb.vyapar.bhagya.datasource.cache.composeApp

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.gsb.vyapar.bhagya.datasource.cache.GsbVyaparBhagyaDatabase
import com.gsb.vyapar.bhagya.datasource.cache.GsbVyaparBhagyaDatabaseQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<GsbVyaparBhagyaDatabase>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = GsbVyaparBhagyaDatabaseImpl.Schema

internal fun KClass<GsbVyaparBhagyaDatabase>.newInstance(driver: SqlDriver): GsbVyaparBhagyaDatabase
    = GsbVyaparBhagyaDatabaseImpl(driver)

private class GsbVyaparBhagyaDatabaseImpl(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver),
    GsbVyaparBhagyaDatabase {
  override val gsbVyaparBhagyaDatabaseQueries: GsbVyaparBhagyaDatabaseQueries =
      GsbVyaparBhagyaDatabaseQueries(driver)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 3

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS categoryEntity(
          |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
          |    name TEXT NOT NULL,
          |    imageUrl TEXT NOT NULL,
          |    deleted INTEGER NOT NULL DEFAULT 0
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS subCategoryEntity(
          |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
          |    name TEXT NOT NULL,
          |    categoryId INTEGER NOT NULL,
          |    deleted INTEGER NOT NULL DEFAULT 0
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS imageCache (
          |    url TEXT PRIMARY KEY,
          |    image BLOB NOT NULL,
          |    last_accessed INTEGER NOT NULL
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS businessEntity(
          |    v INTEGER NOT NULL,
          |    d TEXT NOT NULL,
          |    i INTEGER NOT NULL PRIMARY KEY,
          |    u TEXT NOT NULL
          |)
          """.trimMargin(), 0).await()
    }

    private fun migrateInternal(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      if (oldVersion <= 1 && newVersion > 1) {
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS categoryEntity(
            |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
            |    name TEXT NOT NULL,
            |    imageUrl TEXT NOT NULL,
            |    deleted INTEGER NOT NULL DEFAULT 0
            |)
            """.trimMargin(), 0).await()
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS subCategoryEntity(
            |    id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT,
            |    name TEXT NOT NULL,
            |    categoryId INTEGER NOT NULL,
            |    deleted INTEGER NOT NULL DEFAULT 0
            |)
            """.trimMargin(), 0).await()
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS imageCache (
            |    url TEXT PRIMARY KEY,
            |    image BLOB NOT NULL,
            |    last_accessed INTEGER NOT NULL
            |)
            """.trimMargin(), 0).await()
      }
      if (oldVersion <= 2 && newVersion > 2) {
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS businessEntity(
            |    v INTEGER NOT NULL,
            |    d TEXT NOT NULL,
            |    i INTEGER NOT NULL PRIMARY KEY,
            |    u TEXT NOT NULL
            |)
            """.trimMargin(), 0).await()
      }
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      var lastVersion = oldVersion

      callbacks.filter { it.afterVersion in oldVersion until newVersion }
      .sortedBy { it.afterVersion }
      .forEach { callback ->
        migrateInternal(driver, oldVersion = lastVersion, newVersion = callback.afterVersion +
          1).await()
        callback.block(driver)
        lastVersion = callback.afterVersion + 1
      }

      if (lastVersion < newVersion) {
        migrateInternal(driver, lastVersion, newVersion).await()
      }
    }
  }
}
